<template>
    <div class="fixed inset-x-0 bottom-0 pb-2 sm:pb-5 z-50 ">
      <div class="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
        <div class="rounded-lg bg-green-600 p-2 shadow-lg sm:p-3">
          <div class="flex flex-wrap items-center justify-between">

            <div class="flex  w-full  flex-1 items-center">
              <span class="flex rounded-lg bg-green-800 p-2">
                <ShieldCheckIcon class="h-6 w-6 text-white" aria-hidden="true" />
              </span>
              <p class="ml-3 truncate font-sm text-white">
                <span class="" v-html="msg"></span> <strong v-if="countdown">Automatisch uitloggen in: {{ countdown }}</strong>
     
              </p>
            </div>

            <div class="mt-2 w-full flex-shrink-0 sm:mt-0 sm:w-auto " >

       
                <button @click="onboardOTP(true)" 

                v-if="!isDisabled"
          
                class="inline-flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-2 text-sm font-medium text-gray-800 shadow-sm hover:bg-gray-50">
                  Inschakelen
                    
              </button>

              <button @click="onboardOTP(false)" 
          v-if="!isDisabled"
                class="ml-3 inline-flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-2 text-sm font-medium text-gray-800 shadow-sm hover:bg-gray-50">
                  Overslaan
                    
              </button>
              <a :href="globalVar.urls.logout"

                v-if="isDisabled"

                class="inline-flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-2 text-sm font-medium text-gray-800 shadow-sm hover:bg-gray-50">
                  Opnieuw inloggen
                    
            </a>
             
            </div>
       
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script setup>
import { ShieldCheckIcon } from '@heroicons/vue/24/outline'

</script>


<script>

  export default {
    data() {
      return {

        isDisabled: false,
        msg: "Maak je account extra veilig met <strong>tweestapsauthenticatie</strong>.",
        countdown: null,
      }
    },

    methods: {

        onboardOTP(bool) { 

            this.isDisabled =  true

            // send bool to set the user's otp status

            fetch(`${this.userVar.urls.otp_api}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFTOKEN': `${this.csrfToken.csrf}`,
            },
            body: JSON.stringify({ otp: bool })
            })
            .then(response => Promise.all([response.status, response.json()]))
            .then(([status, data]) => {
  
                if (status == 202) {
                    this.isDisabled =  true
                    this.msg = data.msg

                } else if (status == 200) {
                  console.log(data.msg)
                  console.log("200")
                  this.msg = data.msg
                  this.userVar.user.otp_opt_in = false
          
                } else if (status == 429) {
                  this.isDisabled =  true
                  console.error(data.detail)
          
                  this.msg = "Te veel pogingen gedaan"
                }
              

            })
            .catch((error) => {
                console.error('Error:', error);
                this.msg = data.msg

            throw error
            })

      },
    }
}
</script>